import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { extendedTestimonials, stats, testimonials } from '../data/testimonials';
function Stars() {
  return <div className="flex gap-1 text-brand-gold" aria-label="5 de 5 estrellas" data-id="element-170" data-mp="3gr9fzzylzkl8">
      {[1, 2, 3, 4, 5].map(item => <StarIcon key={item} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-171" data-mp="3bqlold6gx1qh" />)}
    </div>;
}
export function StatsAndProof() {
  return <>
      <section className="border-y border-brand-green/20 bg-brand-ink px-4 py-14 sm:py-20" data-id="element-172" data-mp="3lpujc895qkdw">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-173" data-mp="3btwe4i5y993">
          📊 CUIDADORAS YA DENTRO
        </h2>
        <div className="mx-auto grid max-w-3xl grid-cols-2 gap-x-5 gap-y-10" data-id="element-174" data-mp="3vgxfcvn8c96b">
          {stats.map(({
          value,
          label
        }) => <div key={label} className="text-center" data-id="element-175" data-mp="d7wxd71a41ug">
              <p className="font-display text-4xl font-bold sm:text-6xl" data-id="element-176" data-mp="8bprfe8vuqci">{value}</p>
              <p className="mt-2 text-xs font-semibold leading-tight text-brand-light sm:text-sm" data-id="element-177" data-mp="1gdeb1ns8gq3w">
                {label}
              </p>
            </div>)}
        </div>
      </section>
      <section className="bg-brand-dark px-4 py-16 sm:py-20" data-id="element-178" data-mp="1qaj13yp795pz">
        <div className="mx-auto max-w-6xl" data-id="element-179" data-mp="1qd59g0jwzp99">
          <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-180" data-mp="1ucw62kw4gzlp">
            💬 LO QUE DICEN LAS CUIDADORAS
          </h2>
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-181" data-mp="1z9w9sp5i1q9n">
            {testimonials.map(({
            initials,
            name,
            place,
            quote
          }, index) => <motion.article key={name} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className="flex h-full flex-col rounded-2xl border border-white/10 bg-brand-ink p-6" data-id="element-182" data-mp="292l9ynvlnhpo" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-183" data-mp="myse3c8uw7yw">
                  <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full border border-brand-green/40 font-bold text-brand-light" data-id="element-184" data-mp="mzbma18pfhzq">
                    {initials}
                  </div>
                  <div data-id="element-185" data-mp="wqy6uo6xmtf5">
                    <h3 className="font-bold" data-id="element-186" data-mp="ry52w2jafp44">{name}</h3>
                    <p className="text-sm text-slate-400" data-id="element-187" data-mp="rwlmmbxmte2c">{place}</p>
                  </div>
                </div>
                <div className="mt-5" data-id="element-188" data-mp="16l81ydn9e5tk">
                  <Stars data-id="element-189" data-mp="11o81ci96hv9u" />
                </div>
                <p className="mt-4 italic leading-relaxed text-slate-300" data-id="element-190" data-mp="11ngb7mycopqy">“{quote}”</p>
              </motion.article>)}
          </div>
        </div>
      </section>
    </>;
}
export function ExtendedTestimonials() {
  return <section className="border-y border-white/10 bg-brand-dark px-4 py-14 sm:py-20" data-id="element-191" data-mp="3hf3zyv37nbyo">
      <div className="mx-auto max-w-5xl" data-id="element-192" data-mp="3hgx9qj94ecaw">
        <h2 className="mb-10 text-center font-display text-2xl font-bold text-brand-light sm:text-3xl" data-id="element-193" data-mp="3ch2l6mcthyt0">
          💬 MÁS CUIDADORAS YA DENTRO DEL PROTOCOLO
        </h2>
        <div className="grid gap-7 md:grid-cols-2" data-id="element-194" data-mp="1wws77gs05278">
          {extendedTestimonials.map(({
          name,
          place,
          quote
        }) => <article key={name} className="border-l-2 border-brand-green pl-4" data-id="element-195" data-mp="1j6gebfnlezf1">
              <Stars data-id="element-196" data-mp="1n70bgj862316" />
              <p className="mt-2 font-bold" data-id="element-197" data-mp="1n6gtx3mfhgno">
                {name} <span className="font-normal text-slate-400" data-id="element-198" data-mp="1n4vv31t2zbk0">· {place}</span>
              </p>
              <p className="mt-2 text-sm italic leading-relaxed text-slate-300" data-id="element-199" data-mp="199k3h3a8217b">{quote}</p>
            </article>)}
        </div>
      </div>
    </section>;
}